import React, { useState, useContext, useRef, useEffect } from 'react';
import { Switch, Route, Link } from 'react-router-dom';
import { useToasts } from 'react-toast-notifications';
import { Button, Modal } from 'semantic-ui-react';
import './App.css';
import './Table.css';
import server_config from './ServerConfiguration';
import FevirContext from './FevirContext';
import { signInFirebase, signOutFirebase } from './UserAccountFunctions';
import useOnClickOutside from './useOnClickOutside';
import { loadNotificationNumbers } from './NotificationsFunctions';
import NotificationsView from './NotificationsView';

const node_server_address = server_config["node_server_address"];

{/*}
const NotificationsPanel = ({globalContext}) => {
  return <div className="notificationsModalDiv" style={{ position: "absolute", right: "10px", top: "30px", width: "800px", maxHeight: "70%", height: "600px", margin: "16px", whiteSpace: "pre-wrap", overflow: "visible", "backgroundColor": "#FFFFFF" }}>
      <Modal.Header style={{ padding: "6px 16px 0px 16px", color: "#AC3B61" }}><h2>{alertModalState.header}</h2></Modal.Header>
      <br />
          <NotificationsView globalContext={globalContext} />
          <NotificationsView globalContext={globalContext} />
          <NotificationsView globalContext={globalContext} />
          <NotificationsView globalContext={globalContext} />
          <NotificationsView globalContext={globalContext} />
          <NotificationsView globalContext={globalContext} />
          <NotificationsView globalContext={globalContext} />
          <NotificationsView globalContext={globalContext} />
          <NotificationsView globalContext={globalContext} />
          <NotificationsView globalContext={globalContext} />
          <NotificationsView globalContext={globalContext} />
          <NotificationsView globalContext={globalContext} />
    </div>
} */}

/* I can have it activate by hovering, or maybe by click */
const NotificationModal = ({ notificationHover, notificationLeave, globalContext, notificationModalOpen, setNotificationModalOpen }) => {
  const modalRef = useRef();

  const modalClose = () => {
    setNotificationModalOpen(false);
  }

  useOnClickOutside(modalRef, () => modalClose());

  return <Modal
    className="notificationsModal"
    style={{ right: "10px", top: "30px", width: "900px", maxWidth: "70%", margin: "16px" }}
    onMouseEnter={notificationHover}
    onMouseLeave={notificationLeave}
    open={notificationModalOpen}
    dimmer={false}
    centered={false}
    content={<div ref={modalRef} style={{ whiteSpace: "pre-wrap" }}>
      <div className="notificationsModalDiv scrolling content" style={{ padding: "10px 16px 10px 16px" }}>
        <NotificationsView globalContext={globalContext} />
      </div>
    </div>}
    closeOnEscape
    closeOnDimmerClick={false}
    onClose={modalClose}
  />
}

const ResourceRedirectToast = ({ foi, message }) => {
  //Makes the toast clickable to get to the resource in a new tab
  if (foi) {
    return <div style={{ cursor: "pointer", width: "720px !important" }} onClick={() => { window.open("/" + foi, '_blank').focus(); }}>
      <a target="_blank">{message}</a>
    </div>
  } else {
    return <div><span>{message}</span></div>
  }
}

const FevirNavigationButtons = ({ }) => {
  const { addToast } = useToasts();
  const { notificationBellRef } = useRef();
  const hoverNotificationBellRef = useRef(null);
  const hoverLeaveNotificationBellRef = useRef(null);
  const globalContext = useContext(FevirContext);
  const userState = globalContext.userState;

  const GoogleSignIn = async () => {
    signInFirebase(globalContext);
  }

  const SignOut = async () => {
    signOutFirebase(globalContext);
  }

  useEffect(() => {
    if (userState.idToken) { //And does one more thng to ensure that it wasn't already established, probably another state
      const sseUrl = `${node_server_address}sse?idToken=${encodeURIComponent(userState.idToken)}`;
      const eventSource = new EventSource(sseUrl, {}); //withCredentials: true
      eventSource.onmessage = async (event) => {
        const data = JSON.parse(event.data);
        if (data?.action === "update-notificationnumber-states-and-toast") {
          if (data.message) {
            addToast(<ResourceRedirectToast foi={data.target} message={data.message.substring(0, 500)} />, { appearance: 'info' });
          }
          loadNotificationNumbers(globalContext, true);
          globalContext.setNewNotificationBoolean(true);
        } else if (data?.action === "hello-world") {
          //Placeholder action
        }
        //new Notification('New Notification', { body: "test" }); //Too annoying
        //if (Notification.permission !== 'granted') {
        //  Notification.requestPermission();
        //}
      };

      eventSource.onerror = (error) => {
        console.error('EventSource failed:', error);
        eventSource.close();
      };

      return () => {
        eventSource.close();
      };

    }
  }, [userState?.idToken]);

  const [bellShaking, setBellShaking] = useState(false);
  const [notificationModalOpen, setNotificationModalOpen] = useState(false);

  useEffect(() => {
    if (globalContext.newNotificationBoolean) {
      setBellShaking(true);
      const timer = setTimeout(() => {
        // Sets the bell to have a .shake class and changes it after it's done
        setBellShaking(false);
        if (globalContext.newNotificationBoolean) { //Checks to make sure nothing else set it to false
          globalContext.setNewNotificationBoolean(false);
        }
      }, 500); // Matches the animation duration set in the CSS
      return () => clearTimeout(timer);
    }
  }, [globalContext.newNotificationBoolean]);

  const notificationHover = () => {
    clearTimeout(hoverLeaveNotificationBellRef.current);
    hoverNotificationBellRef.current = setTimeout(() => { setNotificationModalOpen(true); }, 400);
  }

  const notificationLeave = () => {
    clearTimeout(hoverNotificationBellRef.current);
    hoverLeaveNotificationBellRef.current = setTimeout(() => { setNotificationModalOpen(false); }, 600);
  }

  return (
    <span>
      <NotificationModal notificationHover={notificationHover} notificationLeave={notificationLeave} globalContext={globalContext} notificationModalOpen={notificationModalOpen} setNotificationModalOpen={setNotificationModalOpen} />
      <Switch>
        <Route path={""} exact>
          <span style={{ paddingLeft: "20px" }}></span>
          {globalContext.userState.id ?
            <>
              {globalContext.userState.admin && <>
                <Link to={`/admin`}>
                  <Button className="formButton adminButton" content="Admin" compact
                    style={{ paddingLeft: "6px", paddingRight: "6px" }} onClick={() => { }} />
                </Link>
                <span style={{ paddingLeft: "4px" }}></span>
              </>}
              {/* The notification bell can be moved to be to the right of the name, but I wanted to prevent Log Out misclicks */}
              {globalContext.numberUnclearedNotifications > 0 && <span
              > {/* I can have it so it's on hover instead of onClick/ */}
                {/* <Link to={`/content/myresources`}> */}
                <span className={"unselectable " + (bellShaking ? "shake" : "noShake")} style={{ display: "inline-block", textAlign: "left", width: "60px", marginRight: "-36px" }}>
                  <span
                    className={"navigationNotificationBell" + (globalContext.numberUnreadNotifications ? "" : " bellNoUnread")}>
                    <Link to={`/content/myresources`}
                      style={{ cursor: "pointer" }}
                      onMouseEnter={notificationHover}
                      onMouseLeave={notificationLeave}
                      onClick={notificationLeave}
                    /* odisabled={notificationModalOpen} */
                    /* onClick={() => { setNotificationModalOpen(prevstate => !prevstate); }} */
                    >
                      🔔
                    </Link>
                  </span>
                  {globalContext.numberUnreadNotifications > 0 && <span style={{ pointerEvents: "none", display: "inline-block", position: "relative", textAlign: "center", overflow: "visible", top: "-3px", left: "-43.70px", width: "60px" }}>
                    {/* I think it looks a little better not bolded fontWeight: "bold", */}
                    <span style={{ color: "#000000" }}>{globalContext.numberUnreadNotifications < 100 ? globalContext.numberUnreadNotifications : "99+"}</span> {/* Currently 99+ doesn't look good, worse than 100 */}
                  </span>}
                </span>
                {/* </Link> */}
              </span>
              }
              {!globalContext.userState.notificationemail || globalContext.userState.notificationemail === '' ?
                <img style={{ height: '16px' }} src="/red-excl.png"
                  alt="Incomplete profile, please complete"
                  title="Incomplete profile, please complete" />
                :
                <></>
              }
              <span style={{ paddingLeft: "10px" }}></span>
              <Link to={`/editprofile`}>
                <span style={{ textDecoration: 'underline' }}>{globalContext.userState.name || "Edit User Profile"}</span>
              </Link>
              {/*  || !userState.affiliations || userState.affiliations.join('').trim() === '' */}
              <span style={{ paddingLeft: "10px" }}></span>
              <Button className="formButton logOutLogInButton" content="Log Out" compact onClick={SignOut} />
            </>
            :
            <>
              {globalContext.userState.displaythetermsofagreement ?
                <Button className="formButton logOutLogInButton" content="Log Out" compact onClick={SignOut} />
                :
                <Button className="formButton logOutLogInButton" style={{ color: "#000000" }} content="Sign In / Create Account" compact onClick={GoogleSignIn} />
              }
            </>
          }
        </Route>
      </Switch>
    </span>
  );
};

export default FevirNavigationButtons;